(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pooltime-countdown-language"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    const labels = document.getElementById('PooltimeCountdownLabels')?.dataset;
    if (!labels) return;
    const translations = { Days: labels.days, Hrs: labels.hours, Mins: labels.minutes, Secs: labels.seconds };
    const campaignTranslations = { 'Kampanj inför Black month': labels.campaignTitle, 'pågår:': labels.campaignActive };
    const configLabels = { legendCopyDays: 'Days', legendCopyHours: 'Hrs', legendCopyMins: 'Mins', legendCopySecs: 'Secs' };
    const selector = '.essential_countdown_timer [class*="countdown_legend_"]';
    const update = () => {
      const configs = window.essentialCountdownTimerConfigs;
      if (Array.isArray(configs)) configs.forEach(config => {
        if (!config || typeof config !== 'object') return;
        Object.entries(configLabels).forEach(([key, original]) => {
          const translated = translations[original];
          if (config[key] === original && translated) config[key] = translated;
        });
        for (const key of ['title', 'subheading']) {
          const translated = campaignTranslations[config[key]];
          if (translated && config[key] !== translated) config[key] = translated;
        }
      });
      document.querySelectorAll(selector).forEach(label => {
        const translated = translations[label.textContent.trim()];
        if (translated && label.textContent !== translated) label.textContent = translated;
      });
      document.querySelectorAll('.essential_countdown_timer').forEach(timer => {
        const walker = document.createTreeWalker(timer, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.parentElement?.closest('script, style')) continue;
          const translated = campaignTranslations[node.nodeValue.trim()];
          if (translated && node.nodeValue.trim() !== translated) node.nodeValue = translated;
        }
      });
    };
    new MutationObserver(records => {
      if (records.some(record => record.target.closest?.('.countdown-timer-block') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.countdown-timer-block, .essential_countdown_timer') || node.querySelector('.essential_countdown_timer'))))) update();
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    update();
  };
  if (document.getElementById('PooltimeCountdownLabels')) boot();
  else document.addEventListener('DOMContentLoaded', boot, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pooltime-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('pooltime-countdown')) return;
  const readParts = (date, zone) => {
    const result = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(date).forEach(part => { if (part.type !== 'literal') result[part.type] = Number(part.value); });
    return result;
  };
  const parseTime = (input, zone) => {
    const value = (input || '').trim();
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(Z|[+-]\d{2}:\d{2})?$/);
    if (!match) throw new Error('Ange datum och tid: ÅÅÅÅ-MM-DD HH:mm.');
    const [, ys, mos, ds, hs, mis, ss = '0', ms = '0', offset] = match;
    const [year, month, day, hour, minute, second] = [ys, mos, ds, hs, mis, ss].map(Number);
    const utc = Date.UTC(year, month - 1, day, hour, minute, second, Number(ms.padEnd(3, '0')));
    const test = new Date(utc);
    if (year < 2000 || test.getUTCFullYear() !== year || test.getUTCMonth() !== month - 1 || test.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59) throw new Error('Datum eller klockslag är ogiltigt.');
    if (offset) {
      if (offset !== 'Z' && (Number(offset.slice(1, 3)) > 14 || Number(offset.slice(4)) > 59 || (Number(offset.slice(1, 3)) === 14 && Number(offset.slice(4)) !== 0))) throw new Error('Tidszonsförskjutningen är ogiltig.');
      const result = Date.parse(value.replace(' ', 'T'));
      if (!Number.isFinite(result)) throw new Error('Tiden är ogiltig.');
      return result;
    }
    const candidates = new Set();
    for (const shift of [-36, 0, 36]) {
      const probe = utc + shift * 3600000;
      const p = readParts(new Date(probe), zone);
      const delta = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(probe / 1000) * 1000;
      const candidate = utc - delta;
      const actual = readParts(new Date(candidate), zone);
      if (actual.year === year && actual.month === month && actual.day === day && actual.hour === hour && actual.minute === minute && actual.second === second) candidates.add(candidate);
    }
    if (candidates.size !== 1) throw new Error('Tiden saknas eller förekommer två gånger vid byte av sommartid. Ange ISO-tid med +01:00 eller +02:00.');
    return [...candidates][0];
  };
  class PooltimeCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.active = this.querySelector('[data-ptcd-active]');
      this.ended = this.querySelector('[data-ptcd-ended]');
      this.editorNote = this.querySelector('[data-ptcd-editor]');
      this.clock = this.querySelector('[data-ptcd-clock]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector(`[data-ptcd-${key}]`));
      this.onVisibility = () => { this.stop(); this.tick(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      try {
        if (this.dataset.enabled !== 'true') { this.showEditor('Avstängd eller dold av sid-/marknadsval.'); return; }
        const zone = this.dataset.zone || 'Europe/Stockholm';
        new Intl.DateTimeFormat('en', { timeZone: zone });
        this.end = parseTime(this.dataset.end, zone);
        this.start = this.dataset.start?.trim() ? parseTime(this.dataset.start, zone) : -Infinity;
        if (this.start >= this.end) throw new Error('Starttiden måste vara före sluttiden.');
        const locale = this.dataset.locale || document.documentElement.lang || 'sv';
        const deadline = new Intl.DateTimeFormat(locale, { timeZone: zone, dateStyle: 'long', timeStyle: 'long' }).format(new Date(this.end));
        this.querySelector('[data-ptcd-deadline]').textContent = `${this.dataset.deadlineLabel} ${deadline}`;
        this.ready = true;
        this.tick();
      } catch (error) { this.ready = false; this.hidden = true; this.showEditor(error.message); }
    }
    disconnectedCallback() { this.stop(); document.removeEventListener('visibilitychange', this.onVisibility); this.ready = false; }
    stop() { if (this.timeout) clearTimeout(this.timeout); this.timeout = null; }
    showEditor(message) {
      if (this.dataset.editor !== 'true' || !this.editorNote) return;
      this.active.hidden = true; this.ended.hidden = true;
      this.editorNote.textContent = `${this.dataset.editorLabel} ${message}`;
      this.editorNote.hidden = false; this.hidden = false;
    }
    tick() {
      if (!this.ready || !this.isConnected) return;
      const now = Date.now();
      this.stop();
      if (this.editorNote) this.editorNote.hidden = true;
      if (now < this.start) {
        this.hidden = true;
        this.showEditor('Schemalagd. Visas automatiskt vid starttiden.');
        if (!document.hidden) this.timeout = setTimeout(() => this.tick(), Math.min(60000, Math.max(1, this.start - now)));
        return;
      }
      if (now >= this.end) {
        this.active.hidden = true;
        this.ended.hidden = this.dataset.endAction !== 'message';
        this.hidden = this.dataset.endAction !== 'message';
        if (this.hidden) this.showEditor('Sluttiden har passerat. Timern är dold för besökare.');
        return;
      }
      this.hidden = false; this.active.hidden = false; this.ended.hidden = true;
      let seconds = Math.ceil((this.end - now) / 1000);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      values.forEach((value, index) => {
        const next = String(value).padStart(2, '0');
        if (this.units[index].textContent !== next) this.units[index].textContent = next;
      });
      if (!document.hidden) this.timeout = setTimeout(() => this.tick(), Math.min(1000, this.end - now));
    }
  }
  customElements.define('pooltime-countdown', PooltimeCountdown);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pooltime-image-swipe"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    const labels = document.getElementById('PooltimeSwipeLabels')?.dataset;
    if (!labels) return;
    const cards = new WeakSet();
    const galleries = new WeakMap();
    const products = new Map();
    const title = (index, total) => labels.image.replace('[index]', index + 1).replace('[total]', total);
    const dots = (host, count, select) => {
      const nav = document.createElement('div');
      nav.className = 'pt-image-dots notranslate';
      nav.setAttribute('translate', 'no');
      nav.setAttribute('role', 'group');
      nav.setAttribute('aria-label', labels.gallery);
      const buttons = Array.from({ length: count }, (_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', title(index, count));
        button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); select(index); });
        button.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + count) % count;
          select(next);
          buttons[next].hidden = false;
          buttons[next].focus();
        });
        nav.append(button);
        return button;
      });
      const status = document.createElement('span');
      status.className = 'visually-hidden notranslate';
      status.setAttribute('role', 'status');
      host.append(nav, status);
      return {
        update(index, announce = false) {
          const start = Math.max(0, Math.min(count - 5, index - 2));
          buttons.forEach((button, n) => {
            button.hidden = n < start || n >= start + 5;
            button.setAttribute('aria-current', n === index ? 'true' : 'false');
          });
          if (announce) status.textContent = title(index, count);
        },
        error() { status.textContent = labels.error; },
        remove() { nav.remove(); status.remove(); }
      };
    };
    const gesture = (surface, move, warm = () => {}, host = surface) => {
      surface.classList.add('pt-swipe-surface');
      host.classList.add('pt-swipe-host');
      surface.querySelectorAll('img').forEach(image => { image.draggable = false; });
      let start = null;
      let suppressUntil = 0;
      host.addEventListener('dragstart', event => event.preventDefault(), true);
      host.addEventListener('pointerdown', event => {
        if (event.isPrimary === false) { start = null; return; }
        if (event.button !== 0 || event.target.closest('.pt-image-dots, .pt-main-arrow, .slider-button, video, iframe, model-viewer, deferred-media')) return;
        const bounds = surface.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) return;
        start = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
        warm();
      }, true);
      host.addEventListener('pointermove', event => {
        if (!start || start.id !== event.pointerId) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        if (!start.horizontal && Math.abs(y) > 12 && Math.abs(y) > Math.abs(x)) { start = null; return; }
        if (Math.abs(x) > 12 && Math.abs(x) > Math.abs(y) * 1.3) {
          start.horizontal = true;
          if (!host.hasPointerCapture?.(event.pointerId)) host.setPointerCapture?.(event.pointerId);
          event.preventDefault();
        }
      }, { capture: true, passive: false });
      host.addEventListener('pointerup', event => {
        if (!start || start.id !== event.pointerId) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        if (start.horizontal) suppressUntil = performance.now() + 500;
        if (start.horizontal && Math.abs(x) >= 35 && Math.abs(x) > Math.abs(y) * 1.3) move(x < 0 ? 1 : -1);
        start = null;
      }, true);
      host.addEventListener('pointercancel', () => { start = null; }, true);
      host.addEventListener('lostpointercapture', event => { if (event.target === host && start?.id === event.pointerId) start = null; });
      host.addEventListener('click', event => {
        if (performance.now() < suppressUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      surface.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      surface.addEventListener('focusin', warm);
    };
    const productImages = url => {
      const endpoint = new URL(url, location.origin);
      endpoint.search = '';
      endpoint.hash = '';
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      const key = endpoint.href;
      if (!products.has(key)) {
        products.set(key, fetch(key, { credentials: 'same-origin' }).then(response => {
          if (!response.ok) throw new Error('Images unavailable');
          return response.json();
        }).then(product => {
          const media = (product.media || []).filter(item => item.media_type === 'image');
          return product.images.map(src => ({ src, alt: media.find(item => item.src === src)?.alt || product.title }));
        }).catch(error => { products.delete(key); throw error; }));
      }
      return products.get(key);
    };
    const imagePath = src => new URL(src, location.origin).pathname.split('/').pop();
    const initCard = root => {
      const anchor = root.querySelector('.card__media a.media');
      const image = anchor?.querySelector('img');
      const count = Number(root.dataset.imageCount);
      if (!image || count < 2 || cards.has(anchor)) return;
      cards.add(anchor);
      root.classList.add('pt-swipe-card');
      const hoverImage = anchor.querySelector('img[data-pt-hover-src]');
      if (hoverImage) {
        let hoverLoading = false;
        const loadHover = () => {
          if (hoverLoading || !hoverImage.hasAttribute('data-pt-hover-src') || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          hoverLoading = true;
          const loaded = () => {
            hoverImage.removeAttribute('data-pt-hover-src');
            hoverImage.removeAttribute('data-pt-hover-srcset');
            hoverImage.removeEventListener('error', failed);
          };
          const failed = () => {
            hoverLoading = false;
            hoverImage.removeEventListener('load', loaded);
          };
          hoverImage.addEventListener('load', loaded, { once: true });
          hoverImage.addEventListener('error', failed, { once: true });
          hoverImage.loading = 'eager';
          hoverImage.srcset = hoverImage.getAttribute('data-pt-hover-srcset') || '';
          hoverImage.src = hoverImage.getAttribute('data-pt-hover-src');
        };
        anchor.addEventListener('pointerenter', loadHover);
        anchor.addEventListener('focusin', loadHover);
        if (anchor.matches(':hover')) loadHover();
      }
      let images;
      let index = 0;
      let revision = 0;
      const getImages = async () => {
        if (!images) {
          const result = await productImages(root.dataset.productUrl);
          if (!images) {
            images = result;
            index = Math.max(0, images.findIndex(item => imagePath(item.src) === imagePath(image.currentSrc || image.src)));
            controls.update(index);
          }
        }
        return images;
      };
      const select = async (value, relative = false) => {
        try {
          await getImages();
            const next = ((relative ? index + value : value) + images.length) % images.length;
          index = next;
          const token = ++revision;
          const src = new URL(images[next].src, location.origin);
          src.searchParams.set('width', Math.min(1200, Math.max(240, Math.ceil(anchor.clientWidth * Math.min(devicePixelRatio || 1, 2)))));
          src.searchParams.set('quality', '60');
          const preload = new Image();
          preload.src = src.href;
          await preload.decode();
          if (token !== revision || !anchor.isConnected) return;
          image.removeAttribute('srcset');
          image.removeAttribute('data-srcset');
          image.removeAttribute('data-src');
          root.classList.add('pt-swipe-manual');
          image.src = src.href;
          image.alt = images[next].alt;
          controls.update(next, true);
        } catch { controls.error(); }
      };
      const controls = dots(root.querySelector('.card__media'), count, value => select(value));
      controls.update(0);
      gesture(anchor, delta => select(delta, true), () => { getImages().catch(() => {}); }, root);
    };
    const initGallery = gallery => {
      const list = gallery.querySelector('[id^="Slider-Gallery"]');
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!list || !viewer || galleries.get(gallery)?.list === list) return;
      const slides = Array.from(list.children).filter(item => item.dataset.mediaId);
      if (slides.length < 2 || typeof gallery.setActiveMedia !== 'function') return;
      const previous = galleries.get(gallery);
      previous?.observer.disconnect();
      previous?.controls.remove();
      gallery.classList.add('pt-swipe-gallery');
      const selected = () => Math.max(0, slides.findIndex(item => item.classList.contains('is-active')));
      const select = index => {
        const slide = slides[(index + slides.length) % slides.length];
        gallery.setActiveMedia(slide.dataset.mediaId, false, true);
      };
      const controls = dots(viewer, slides.length, select);
      controls.update(selected());
      const observer = new MutationObserver(() => controls.update(selected()));
      observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      gesture(list, delta => select(selected() + delta), () => {}, viewer);
      galleries.set(gallery, { list, observer, controls });
    };
    const watchedCards = new WeakSet();
    const cardObserver = 'IntersectionObserver' in window && document.querySelector('[data-pooltime-pooltak-accessibility]')
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            cardObserver.unobserve(entry.target);
            watchedCards.delete(entry.target);
            initCard(entry.target);
          });
        }, { rootMargin: '240px 0px' })
      : null;
    const prepareCard = root => {
      const anchor = root.querySelector('.card__media a.media');
      if (!anchor || Number(root.dataset.imageCount) < 2 || cards.has(anchor) || watchedCards.has(root)) return;
      if (!cardObserver) { initCard(root); return; }
      watchedCards.add(root);
      const activate = () => {
        cardObserver.unobserve(root);
        watchedCards.delete(root);
        root.removeEventListener('focusin', activate);
        root.removeEventListener('pointerenter', activate);
        initCard(root);
      };
      root.addEventListener('focusin', activate, { once: true });
      root.addEventListener('pointerenter', activate, { once: true });
      cardObserver.observe(root);
    };
    const scan = () => {
      document.querySelectorAll('[data-pooltime-card]').forEach(prepareCard);
      document.querySelectorAll('media-gallery').forEach(initGallery);
    };
    let queued = false;
    new MutationObserver(records => {
      const relevant = records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-pooltime-card], media-gallery') || node.querySelector('[data-pooltime-card], media-gallery') || node.closest('[data-pooltime-card], media-gallery'))));
      if (!relevant || queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scan);
    customElements.whenDefined('media-gallery').then(scan);
    scan();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pooltime-lazy-category-sidebar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pooltime-lazy-category-sidebar')) {
  customElements.define('pooltime-lazy-category-sidebar', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.hydrated === 'true') return;
      this.drawer = this.closest('details');
      this.summary = this.drawer?.querySelector(':scope > summary');
      this.prepare = event => {
        if (event.target.closest('summary') !== this.summary) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        this.hydrate();
      };
      this.onToggle = () => { if (this.drawer.open) this.hydrate(); };
      if (!this.drawer || this.drawer.open) { this.hydrate(); return; }
      this.drawer.addEventListener('pointerdown', this.prepare, true);
      this.drawer.addEventListener('click', this.prepare, true);
      this.drawer.addEventListener('keydown', this.prepare, true);
      this.drawer.addEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      if (!this.drawer) return;
      this.drawer.removeEventListener('pointerdown', this.prepare, true);
      this.drawer.removeEventListener('click', this.prepare, true);
      this.drawer.removeEventListener('keydown', this.prepare, true);
      this.drawer.removeEventListener('toggle', this.onToggle);
    }
    hydrate() {
      const template = this.querySelector(':scope > template');
      if (!template) return;
      this.append(template.content.cloneNode(true));
      template.remove();
      this.dataset.hydrated = 'true';
      this.cleanup();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pooltime-mobile-footer"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = matchMedia('(max-width: 749px)');
  const onReady = () => {
    const copy = document.getElementById('pt-mobile-copy')?.dataset;
    if (!copy) return;
    document.querySelectorAll('.footer-block--menu > button').forEach(button => {
      button.addEventListener('click', event => {
        if (!mobile.matches) return;
        event.preventDefault(); event.stopImmediatePropagation();
        button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
      }, true);
    });
    const city = document.querySelector('.city-banner__wrapper');
    if (city) {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'pt-city-toggle'; button.textContent = copy.cities; button.setAttribute('aria-expanded','false');
      button.addEventListener('click', () => { const open = city.classList.toggle('pt-cities-open'); button.setAttribute('aria-expanded',String(open)); });
      city.prepend(button); city.classList.add('pt-city-ready');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',onReady,{once:true}); else onReady();
})();
  } catch(e) { console.error(e); }
})();

})();
